<div class="main-container" data-cy="patient-portal-correspondence-main-container">
  <div class="main-title" data-cy="patient-portal-correspondence-main-title-text">Correspondence
    <div class="sub-container" data-cy="patient-portal-correspondence-expand-all-checkbox-container">
      <mat-checkbox (change)="expandAll($event)" data-cy="patient-portal-correspondence-expand-all-checkbox-input">Expand All</mat-checkbox>
    </div>
  </div>


  <div class="appointments-container" data-cy="patient-portal-correspondence-appointments-container">
    @if (appointments?.length===0) {
      <div class="general-content-container recent-appointment-container" data-cy="patient-portal-correspondence-no-appointments-text-container">
        <span class="container-title" data-cy="patient-portal-correspondence-no-appointments-text">No Appointments</span>
      </div>
    }

    @for (appt of (appointments | itemFilter: ContainsAppointmentCorrespondence); track appt) {
      <div class="appointment-data recent-entity" data-cy="patient-portal-correspondence-appointment-item">
        @if (appt.correspondence.length>0) {
          <div
            (click)="toggleCorrespondence(appt.AppointmentId)" data-cy="patient-portal-correspondence-appointment-toggle">
            <div class="correspondence-label" data-cy="patient-portal-correspondence-appointment-label">
              <i class="tiny-icon material-symbols-outlined" style="font-size: 14px !important; margin-right: 10px;" data-cy="patient-portal-correspondence-appointment-expand-icon">{{ appt.AppointmentId == activeAppointmentId ||
              activeAppointmentId =='all'? 'expand_less':'expand_more' }}</i>
              {{ appt.appointmentDate.format('D MMM, YYYY')}} -
              {{appt.procedureDescription}}
            </div>
          </div>
        }
        <div [style.display]="appt.AppointmentId === activeAppointmentId || activeAppointmentId ==='all' ? 'block':'none'" data-cy="patient-portal-correspondence-appointment-files-container">
          @for (file of appt.correspondence; track file) {
            <div style="flex-direction: row; display: flex; cursor: pointer;" (click)="openCorrespondenceFile(file)" data-cy="patient-portal-correspondence-file-item">
              <div style="flex-direction: row; display: flex;" data-cy="patient-portal-correspondence-file-info-container">
                <div style="padding-left: 15px;padding-right: 15px;" data-cy="patient-portal-correspondence-file-icon-container"><i
                class="tiny-icon material-symbols-outlined" data-cy="patient-portal-correspondence-file-icon">file_open</i></div>
                <div data-cy="patient-portal-correspondence-file-description-text">{{ file.Description }} ( {{ file.DocumentCreateDate | date:'short' }})</div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="action-container" data-cy="patient-portal-correspondence-close-button-container">
    <button mat-button class="tdo-close" color="warn" (click)="close()" data-cy="patient-portal-correspondence-close-action-button">Close</button>
  </div>
</div>